import React, { Component } from 'react';
import { Switch, Route, HashRouter } from 'react-router-dom';
import "./weekOffs.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';
import moment from 'moment';
import config from 'config';
import LibraryApiCall from 'LibraryApiCall';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import DeleteModal from 'LIBRARY/CommonResources/DeleteModal/DeleteModal';
import Spinner from 'LIBRARY/CommonResources/SpinnerLoader/Spinner';
import { default as ReactSelect, components, InputProps } from "react-select";
import ReactHtmlParser from 'react-html-parser';
import Pagination from 'react-js-pagination';
import { connect } from 'react-redux';

class WeekOffs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 'holidays',
            filterModal: false,
            weekOffList: {},
            totalWeekOffs: '',
            LoadingWeekoffs: false,
            offset: 0,
            pageIndex: 1,
            limit: 10,

            //SUCCESS MODAL VARIABLES
            successModal: false,
            successModalType: "",
            successMessage: "",

            // METHOD TO RETURN DELETE
            deleteAccess: false,
            deletingAccess: '',
            deleteAccessText: '',
            deleteWarning: '',
            deletingId: '',

            selectedDepartmentObject: '',
            selectedDepartment: [],
            departmentList: {},

            AcademicYearList: [],
            selectedAcademicYearObject: '',
            selectedAcademicYear: [],
            validFromDate: '',
            validToDate: '',
            selectedIid: '',
            departments: {},
            editAcaYear: '',
            uniqueIdEdit: '',

            // FILTERS
            filterModal: false,
            filterApplied: false,
            filterIid: '',
            filterAcaYr: '',
            filterDepartment: '',
            filterFromDate: '',
            filterToDate: '',
            isValid: true,

            // add week off 
            addWeekOff: false,

            weekOffEditMode: false,
            weekOffCopyMode: false,

            isEmpty: false,
            errorMessage: '',
            dateErrorMessage: '',

            selectedCheckboxes: {},

            weekDays: [
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday',
                'Sunday',
            ],
        }
    }

    componentDidMount() {
        this.apiCallToGetWeekOffsList();
    }

    // API CALL TO GET WEEK OFFS DATA LIST
    apiCallToGetWeekOffsList = async () => {
        this.setState({
            LoadingWeekoffs: true
        });

        let iidArray = [];

        if (this.state.filterIid != '') {
            iidArray = [this.state.filterIid]
        } else {
            iidArray = this.props.iidArray.iidArray // this.props.assignedIIDArray
        }

        let requestData = {
            "iidArray": iidArray,
            "sid": this.state.filterDepartment,
            "fromDate": this.state.filterFromDate,
            "toDate": this.state.filterToDate,
            "acaYearId": this.state.filterAcaYr,
            "limit": this.state.limit,
            "offset": this.state.offset,
        }
        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getLibraryWeekOff',
            requestData,
            "/api/library/libraryWeekoffs.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetWeekOffsList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.success == 'true') {

                    this.setState({
                        weekOffList: apiResult.data,
                        totalWeekOffs: apiResult.Total,
                        LoadingWeekoffs: false
                    })
                }
                else {
                    this.setState({
                        weekOffList: {},
                    })
                }
            } else {
                this.setState({
                    weekOffList: {},
                })
            }
        }
    }

    // API CALL TO GET FACULTY STREAM DATA LIST
    GetInstituteStreamsObject = async () => {

        let getIid = '';

        if (this.state.filterIid != '') {
            getIid = this.state.filterIid
        } else {
            getIid = this.state.selectedIid
        }

        let requestData = {
            "iid": getIid,
        }
        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetInstituteStreamsObject',
            requestData,
            "/api/admission/streamManagement.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetInstituteStreamsObject();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.success == 'true') {

                    this.departmentList(apiResult.data)

                    this.setState({
                        departments: apiResult.data,
                    })

                }
                else {
                    this.setState({
                        departmentList: [],
                        departments: {}
                    })
                }
            } else {
                this.setState({
                    departmentList: [],
                    departments: {}
                })
            }
        }
    }

    //Below method will add new week off by making an API call.
    apiCallToAddWeekOff = async () => {

        let academicYear = '';

        if (this.state.weekOffCopyMode) {
            academicYear = [this.state.editAcaYear]
        } else {
            academicYear = this.state.selectedAcademicYear
        }

        let requestData = {
            'institute_id': this.state.selectedIid,
            'aca_year': academicYear,
            'department': this.state.selectedDepartment,
            'fromDate': this.state.validFromDate,
            'toDate': this.state.validToDate,
            'weekOffDays': this.state.selectedCheckboxes,
            'addedBy': config.faculty_id,
        }

        //Following method will make an API call and return a response.
        let jsonResponse = await LibraryApiCall.makeApiCall(
            "addLibraryWeekOff",
            requestData,
            "/api/library/libraryWeekoffs.php",
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToAddWeekOff();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                if (jsonResponse.APIResult.status === 'success') {
                    this.setState({
                        successModal: true,
                        successModalType: 'success',
                        successMessage: ReactHtmlParser(jsonResponse.APIResult.message),
                    }, () => { this.apiCallToGetWeekOffsList(); this.closeAddWeekOff() });
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: jsonResponse.APIResult.message,
                    });
                }
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while adding week off. Please try again later.',
                });
            }
        }
    }

    // API CALL METHOD TO DELETE week off
    apiCallToDeleteWeekOff = async () => {

        let requestData = {
            "institute_id": this.state.CollegeId,
            "unique_id": this.state.deletingId,
            "deletedBy": config.faculty_id
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'deleteLibraryWeekOff',
            requestData,
            '/api/library/libraryWeekoffs.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToDeleteWeekOff();
            }, 1000);
        }
        else {
            this.closeDeleteWeekoff();
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                if (apiResult.status == 'success') {

                    this.setState({
                        // deletingAccess: false,
                        successModal: true,
                        successModalType: 'success',
                        successMessage: apiResult.message,
                    }, () => this.apiCallToGetWeekOffsList());
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message
                    });
                }
            }
            else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while deleting week off. Please try again later.'
                });
            }
        }
    }

    // API  CALL METHOD TO UPDATE week off DETAILS
    apiCallToUpdateWeekOff = async () => {

        let requestData = {
            "institute_id": this.state.selectedIid,
            "department": this.state.selectedDepartment,
            "aca_year": this.state.editAcaYear,
            "fromDate": this.state.validFromDate,
            "toDate": this.state.validToDate,
            "updatedBy": config.faculty_id,
            "unique_id": this.state.uniqueIdEdit,
            "weekOffDays": this.state.selectedCheckboxes
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'updateLibraryWeekOff',
            requestData,
            '/api/library/libraryWeekoffs.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToUpdateWeekOff();
            }, 1000);
        }
        else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.status == 'success') {

                    this.setState({
                        successModal: true,
                        successModalType: 'success',
                        successMessage: ReactHtmlParser(jsonResponse.APIResult.message),
                    }, () => { this.apiCallToGetWeekOffsList(); this.closeAddWeekOff() });
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });
                }
            }
            else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while updating week off. Please try again later.'
                });
            }
        }
    }

    // METHOD TO SELECT LIMIT
    selectLimit = (e) => {
        this.setState({
            limit: e.target.value,
            pageIndex: 1,
            offset: 0,
        }, () => {
            // METHOD CALLED TO GET week offs DETAILS
            this.apiCallToGetWeekOffsList();
        });
    }

    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false
        });
    }

    // METHOD TO UPDATE PAGINATION PAGE NUMBER
    updatePaginationCount = (pageNumber) => {
        this.setState({
            pageIndex: pageNumber,
            offset: (pageNumber - 1) * this.state.limit,
        }, () => {
            // METHOD CALLED TO GET week offs DETAILS
            this.apiCallToGetWeekOffsList();
        });
    }

    // METHOD TO SELECT EVENT TYPE
    selectEventType = (type) => {
        if (this.state.activeTab != type) {
            this.setState({
                activeTab: type
            })
        }
    }

    // METHODS TO SET STATES
    departmentList = (departmentData) => {
        let departmentList = [];
        Object.keys(departmentData).map((keys, index) => {
            let department = departmentData[keys]
            let options = { "value": keys, "label": department.stream_name };
            departmentList.push(options);
        })
        this.setState({
            departmentList: departmentList,
        })
    }

    AcademicYearList = () => {
        let AcademicYearList = [];
        Object.keys(config.academicInfo).map((keys) => {
            let acaYear = config.academicInfo[keys]
            let options = { "value": acaYear.YearId, "label": acaYear.YearText };
            AcademicYearList.push(options);
        })
        this.setState({
            AcademicYearList: AcademicYearList,
        })
    }

    //Date Validation
    validateDates = () => {

        if (this.state.filterFromDate.length > 0) {
            if (
                this.state.filterFromDate.length &&
                this.state.filterToDate.length &&
                this.state.filterToDate < this.state.filterFromDate) {
                this.setState({
                    isValid: false,
                    dateErrorMessage: 'To Date cannot be before than from date.'
                })
            } else {
                this.setState({
                    isValid: true,
                    dateErrorMessage: ''
                })
            }
        } else {
            if (
                this.state.validFromDate.length &&
                this.state.validToDate.length &&
                this.state.validToDate < this.state.validFromDate) {
                this.setState({
                    isEmpty: true,
                    isValid: false,
                    dateErrorMessage: 'To Date cannot be before than from date.'
                })
            } else {
                this.setState({
                    isEmpty: false,
                    isValid: true,
                    dateErrorMessage: ''
                })
            }
        }
    }

    // METHOD TO CHECK ACCESS FOR ADD OPERATION
    checkAddWeekOffs = () => {
        const addGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['setting'].find(access => access === 'add');

        if (addGrantAccess !== undefined) {
            this.setState({
                addWeekOff: true,
                weekOffEditMode: false,
                weekOffCopyMode: false,
            });
        }
        else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    // METHOD TO CLOSE ADD WEEK OFF MODAL
    closeAddWeekOff = () => {
        this.setState({
            addWeekOff: false,
            validToDate: '',
            validFromDate: '',
            selectedIid: '',
            selectedAcademicYearObject: [],
            selectedAcademicYear: '',
            selectedDepartment: '',
            selectedDepartmentObject: [],
            errorMessage: '',
            dateErrorMessage: '',
            selectedCheckboxes: {}
        });
    }

    getSuffix = (weekNumber) => {
        if (weekNumber >= 11 && weekNumber <= 13) {
            return "th";
        } else {
            switch (weekNumber % 10) {
                case 1: return "st";
                case 2: return "nd";
                case 3: return "rd";
                default: return "th";
            }
        }
    }

    selectAcaYear = (selectedOption) => {
        let selectAcaYear = this.state.selectedAcademicYear;
        selectAcaYear = [];

        if (selectedOption.length > 0) {
            selectedOption.map(option => {
                if (!selectAcaYear.includes(option.value)) {
                    selectAcaYear.push(option.value);
                }
            })
        }
        this.setState({
            selectedAcademicYear: selectAcaYear
        });
    }

    selectDepartments = (selectedOption) => {
        let selectDepartment = this.state.selectedDepartment;
        selectDepartment = [];

        if (selectedOption.length > 0) {
            selectedOption.map(option => {
                if (!selectDepartment.includes(option.value)) {
                    selectDepartment.push(option.value);
                }
            })
        }
        this.setState({
            selectedDepartment: selectDepartment
        });
    }

    // METHOD TO RETURN DELETE ACCESS
    returnDeleteAccess = () => {
        return (
            <div className={this.state.deleteAccess ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog" style={{ marginTop: '10%', marginLeft: '25%', }} >
                    <div className="modal-content " style={{ width: '50vw' }}>
                        <div className="modal-header  deleteModalHeader">
                            <h2 style={{ color: "white" }}><FontAwesomeIcon icon={['fas', 'exclamation-triangle']} color="white" size="am" style={{ marginRight: 20 }} /> Are you sure?</h2>
                            <FontAwesomeIcon icon={['fas', 'times']} size="lg" color="white" onClick={() => this.closeDeleteWeekoff()} style={{ cursor: "pointer" }} />
                        </div>
                        <div className="modal-body deleteModalBody">
                            <p style={{ fontSize: 16, fontWeight: "bold" }}>NOTE:</p>
                            <ul className="pl-5">
                                <li>Once deleted cannot be retrieved.</li>
                                <li>All data associated with this entry will be deleted permanently.</li>
                            </ul>
                            <p className="pl-5 deleteConfirmationText">If you want to delete the entry , type <b>DELETE PERMANENTLY</b> in block/capital letters in below input text for confirmation.</p>
                            <div className="pl-5">
                                <input
                                    type="text"
                                    style={{ width: "260px" }}
                                    value={this.state.deleteAccessText}
                                    onChange={(e) => e.target.value != 'DELETE PERMANENTLY' ? this.setState({ deleteAccessText: e.target.value, deleteWarning: 'Please enter DELETE PERMANENTLY to delete access.' }) : this.setState({ deleteAccessText: e.target.value, deleteWarning: '' })}
                                    placeholder="Please type DELETE PERMANENTLY"
                                    maxLength={18}
                                    onPaste={(e) => e.preventDefault()}
                                />
                            </div>
                            <p style={{ marginLeft: 50, color: 'red', fontSize: 12, marginTop: 5 }}>{this.state.deleteWarning}</p>
                        </div>

                        <div className="modal-footer">
                            <div id="addCategoryButtonContainer" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                {
                                    this.state.deletingAccess &&
                                    <Spinner />
                                }
                                <button className="btn btn-outline-primary waves-effect" onClick={() => this.state.deleteAccessText == 'DELETE PERMANENTLY' ? this.apiCallToDeleteWeekOff() : this.setState({ deleteWarning: 'Please enter DELETE PERMANENTLY to delete access.' })} disabled={this.state.deletingAccess}>Yes</button>
                                <button className="btn btn-primary" onClick={() => this.closeDeleteWeekoff()}>No</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO CHECK ACCESS FOR DELETE OPERATION
    checkDeleteAccess = () => {

        const deleteGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['setting'].find(access => access === 'delete');

        if (deleteGrantAccess !== undefined) {
            this.setState({
                deleteAccess: true
            });
        }
        else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    // METHOD TO CLOSE DELETE ACCESS
    closeDeleteWeekoff = () => {
        this.setState({
            deleteAccess: false,
            deletingAccess: false,
            deleteAccessText: '',
            deleteWarning: ''
        });
    }

    // METHOD TO RETURN ADD NEW WEEK OFF
    returnAddNewWeekOff = () => {
        const customStyles = {
            option: (provided) => ({
                ...provided,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '100%',
                fontSize: '10px'
            }),
        };
        return (
            <div id="addAccessSideMenu" style={{ display: this.state.addWeekOff ? 'flex' : 'none' }}>
                <div id="addWeekOffDataContainer" style={{ borderTopLeftRadius: '10px', borderBottomLeftRadius: '10px' }}>
                    <div className='pl-4 pr-2'>
                        <div className="d-flex justify-content-between pt-4 pb-2">
                            <h5 className="col-11 pl-4">{this.state.weekOffEditMode ? "Update Week offs" : this.state.weekOffCopyMode ? "Copy Week offs" : "Add Week offs"}</h5>
                            <span className="pr-4">
                                <FontAwesomeIcon icon={['fas', 'times']} size="md" color="#000" onClick={() => this.closeAddWeekOff()} style={{ cursor: "pointer" }} />
                            </span>
                        </div>
                        <hr className='pl-4' />
                        <div className="col-md-12 pt-3">
                            {
                                !this.state.weekOffEditMode &&
                                <div className="">
                                    <label style={{ fontWeight: "bold", fontSize: "14px" }}>Institute<span style={{ color: 'red' }}> *</span></label>

                                    <select
                                        className="form-control"
                                        value={this.state.selectedIid}
                                        onChange={(e) => { this.setState({ selectedIid: e.target.value, departmentList: [], selectedDepartmentObject: '', selectedDepartment: [], selectedAcademicYearObject: '' }, () => { this.GetInstituteStreamsObject(); }) }}
                                    >
                                        <option value="">Select Institute</option>
                                        {
                                            Object.values(this.props.multipleInstituteDetails.multipleInstituteDetails).map(instituteList => {
                                                return (
                                                    <option value={instituteList.iid}>{instituteList.institute_name}</option>
                                                );
                                            })
                                        }
                                    </select>
                                </div>
                            }
                            <div className='d-flex pt-3'>
                                <div className="col-md-6 pl-0">
                                    <label style={{ fontWeight: "bold", fontSize: "14px" }}>Academic Year<span style={{ color: 'red' }}> *</span></label>

                                    {
                                        this.state.weekOffEditMode || this.state.weekOffCopyMode ?
                                            (
                                                <select
                                                    className="form-control"
                                                    value={this.state.editAcaYear}
                                                    onChange={(e) => { this.setState({ editAcaYear: e.target.value }, () => { this.GetInstituteStreamsObject(); }) }}
                                                >
                                                    <option value="">Select Academic Year</option>
                                                    {
                                                        Object.values(config.academicInfo).map(keys => {
                                                            return (
                                                                <option value={keys.YearId}>{keys.YearText}</option>
                                                            );
                                                        })
                                                    }
                                                </select>
                                            )
                                            :
                                            (
                                                <ReactSelect
                                                    className='upperSelectBoxZIndex'
                                                    value={this.state.selectedAcademicYearObject}
                                                    options={this.state.AcademicYearList}
                                                    defaultValue=""
                                                    isMulti
                                                    isClearable
                                                    closeMenuOnSelect={false}
                                                    hideSelectedOptions={false}
                                                    styles={customStyles}
                                                    onChange={(e) => {
                                                        this.setState({ selectedAcademicYearObject: e })
                                                        this.selectAcaYear(e)
                                                    }
                                                    }
                                                />
                                            )
                                    }
                                </div>
                                <div className="col-md-6 pr-0">
                                    <label style={{ fontWeight: "bold", fontSize: "14px" }}>Department<span style={{ color: 'red' }}> *</span></label>

                                    <ReactSelect
                                        className='upperSelectBoxZIndex'
                                        value={this.state.selectedDepartmentObject}
                                        options={this.state.departmentList}
                                        defaultValue=""
                                        isMulti
                                        isClearable
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        styles={customStyles}
                                        isDisabled={!this.state.selectedIid}
                                        onChange={(e) => {
                                            this.setState({ selectedDepartmentObject: e })
                                            this.selectDepartments(e)
                                        }
                                        }
                                    />
                                </div>
                            </div>
                            <div className='d-flex pt-3'>
                                <div className="col-md-6 pl-0">
                                    <label style={{ fontWeight: "bold", fontSize: "14px" }}>From Date<span style={{ color: 'red' }}> *</span></label>

                                    <input
                                        type="date"
                                        className="form-control"
                                        style={{ width: "100%", paddingLeft: "10px" }}
                                        value={this.state.validFromDate}
                                        onChange={(e) => { this.setState({ validFromDate: e.target.value }, () => { this.validateDates(); }) }}
                                    />
                                </div>
                                <div className="col-md-6 pr-0">
                                    <label style={{ fontWeight: "bold", fontSize: "14px" }}>To Date<span style={{ color: 'red' }}> *</span></label>

                                    <input
                                        type="date"
                                        className="form-control"
                                        style={{ width: "100%", paddingLeft: "10px" }}
                                        value={this.state.validToDate}
                                        disabled={!this.state.validFromDate}
                                        onChange={(e) => { this.setState({ validToDate: e.target.value }, () => { this.validateDates(); }) }}
                                    />
                                </div>
                            </div>
                            <p className='text-danger fs-12 pt-1'>{this.state.dateErrorMessage}</p>
                            <div className='pt-4'>
                                <label style={{ fontWeight: "bold", fontSize: "14px" }}>Select Week Off Days <span style={{ color: 'red' }}> *</span></label>

                                <table className="table table-bordered jumbotron mt-3">
                                    <tbody style={{ backgroundColor: "white" }}>

                                        {this.state.weekDays.length > 0 &&
                                            this.state.weekDays.map((day, dayIndex) => {
                                                return (
                                                    <>
                                                        <tr className="p-3">
                                                            <th style={{ backgroundColor: '#f2f8fc' }}>
                                                                <div class="col form-check pl-4">
                                                                    {/* <input class="form-check-input" type="checkbox" value="" id="defaultCheck1" /> */}
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        value=""
                                                                        id={`checkbox-${day}`}
                                                                        onChange={() => this.toggleHeaderCheckbox(day)}
                                                                        checked={this.state.selectedCheckboxes[day] && this.state.selectedCheckboxes[day].length === 6}
                                                                    />
                                                                    <label class="form-check-label" htmlFor={`checkbox-${day}`}>
                                                                        {day}
                                                                    </label>
                                                                </div>
                                                            </th>
                                                            <td className="pl-3" style={{ paddingRight: 10 }}>
                                                                <div className="row">
                                                                    <div class="col form-check pl-4">
                                                                        {/* <input class="form-check-input" type="checkbox" value="" id="defaultCheck1" /> */}
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            value=""
                                                                            id={`checkbox-${day}-1`}
                                                                            onChange={() => this.toggleCheckbox(day, 1)}
                                                                            checked={this.state.selectedCheckboxes[day] && this.state.selectedCheckboxes[day].includes(1)}
                                                                        />
                                                                        <label class="form-check-label" htmlFor={`checkbox-${day}-1`}>
                                                                            1st
                                                                        </label>
                                                                    </div>
                                                                    <div class="col form-check pl-3">
                                                                        {/* <input class="form-check-input" type="checkbox" value="" id="defaultCheck1" /> */}
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            value=""
                                                                            id={`checkbox-${day}-2`}
                                                                            onChange={() => this.toggleCheckbox(day, 2)}
                                                                            checked={this.state.selectedCheckboxes[day] && this.state.selectedCheckboxes[day].includes(2)}
                                                                        />
                                                                        <label class="form-check-label" htmlFor={`checkbox-${day}-2`}>
                                                                            2nd
                                                                        </label>
                                                                    </div>
                                                                    <div class="col form-check pl-3">
                                                                        {/* <input class="form-check-input" type="checkbox" value="" id="defaultCheck1" /> */}
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            value=""
                                                                            id={`checkbox-${day}-3`}
                                                                            onChange={() => this.toggleCheckbox(day, 3)}
                                                                            checked={this.state.selectedCheckboxes[day] && this.state.selectedCheckboxes[day].includes(3)}
                                                                        />
                                                                        <label class="form-check-label" htmlFor={`checkbox-${day}-3`}>
                                                                            3rd
                                                                        </label>
                                                                    </div>
                                                                    <div class="col form-check pl-3">
                                                                        {/* <input class="form-check-input" type="checkbox" value="" id="defaultCheck1" /> */}
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            value=""
                                                                            id={`checkbox-${day}-4`}
                                                                            onChange={() => this.toggleCheckbox(day, 4)}
                                                                            checked={this.state.selectedCheckboxes[day] && this.state.selectedCheckboxes[day].includes(4)}
                                                                        />
                                                                        <label class="form-check-label" htmlFor={`checkbox-${day}-4`}>
                                                                            4th
                                                                        </label>
                                                                    </div>
                                                                    <div class="col form-check pl-3">
                                                                        {/* <input class="form-check-input" type="checkbox" value="" id="defaultCheck1" /> */}
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            value=""
                                                                            id={`checkbox-${day}-5`}
                                                                            onChange={() => this.toggleCheckbox(day, 5)}
                                                                            checked={this.state.selectedCheckboxes[day] && this.state.selectedCheckboxes[day].includes(5)}
                                                                        />
                                                                        <label class="form-check-label" htmlFor={`checkbox-${day}-5`}>
                                                                            5th
                                                                        </label>
                                                                    </div>
                                                                    <div class="col form-check pl-3">
                                                                        {/* <input class="form-check-input" type="checkbox" value="" id="defaultCheck1" /> */}
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            value=""
                                                                            id={`checkbox-${day}-6`}
                                                                            onChange={() => this.toggleCheckbox(day, 6)}
                                                                            checked={this.state.selectedCheckboxes[day] && this.state.selectedCheckboxes[day].includes(6)}
                                                                        />
                                                                        <label class="form-check-label" htmlFor={`checkbox-${day}-6`}>
                                                                            6th
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </>
                                                )
                                            }
                                            )
                                        }
                                        <tr>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <p className='text-danger fs-12'>{this.state.errorMessage}</p>
                        </div>
                        <div id="addWeekoffFooter" className="modal-footer pt-3">
                            <button className="btn btn-outline-primary waves-effect" onClick={() => this.closeAddWeekOff()}>Cancel</button>
                            <button className="btn btn-primary"
                                onClick={() => this.validateAddWeekOff()}
                            > {this.state.weekOffEditMode ? "Update Week offs" : this.state.weekOffCopyMode ? "Copy Week offs" : "Add Week offs"}</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    toggleHeaderCheckbox = (day) => {
        const isChecked = !this.state.selectedCheckboxes[day] || this.state.selectedCheckboxes[day].length === 0;
        const selectedCheckboxes = { ...this.state.selectedCheckboxes };
        selectedCheckboxes[day] = isChecked ? [1, 2, 3, 4, 5, 6] : [];
        if (selectedCheckboxes[day].length === 0) {
            delete selectedCheckboxes[day];
        }
        this.setState({ selectedCheckboxes });
    };

    toggleCheckbox = (day, weekNumber) => {
        const selectedCheckboxes = {};
        const selectedCheckboxKeys = Object.keys(this.state.selectedCheckboxes);
        for (let i = 0; i < selectedCheckboxKeys.length; i++) {
            const key = selectedCheckboxKeys[i];
            selectedCheckboxes[key] = this.state.selectedCheckboxes[key];
        }

        if (!selectedCheckboxes[day]) {
            selectedCheckboxes[day] = [];
        }
        const index = selectedCheckboxes[day].indexOf(weekNumber);
        if (index === -1) {
            selectedCheckboxes[day].push(weekNumber);
        } else {
            selectedCheckboxes[day].splice(index, 1);
        }

        if (selectedCheckboxes[day].length === 0) {
            delete selectedCheckboxes[day];
        }

        this.setState({ selectedCheckboxes });
    };

    // METHOD TO VALIDATE ADD WEEK OFF
    validateAddWeekOff = () => {

        if (this.state.weekOffEditMode) {

            if (Object.keys(this.state.selectedCheckboxes).length == 0 || this.state.selectedIid == '' || this.state.editAcaYear == '' || this.state.selectedDepartmentObject == '' || this.state.validFromDate == '' || this.state.validToDate == '') {
                this.setState({
                    isEmpty: true,
                    errorMessage: 'Please fill out all mandatory fields before proceeding.'
                });
            } else if (this.state.isValid == true) {
                this.setState({
                    isEmpty: false,
                    errorMessage: ''
                }, () => {
                    this.apiCallToUpdateWeekOff();
                });
            }
        } else if (this.state.weekOffCopyMode) {

            if (Object.keys(this.state.selectedCheckboxes).length == 0 || this.state.selectedIid == '' || this.state.editAcaYear == '' || this.state.selectedDepartmentObject == '' || this.state.validFromDate == '' || this.state.validToDate == '') {
                this.setState({
                    isEmpty: true,
                    errorMessage: 'Please fill out all mandatory fields before proceeding.'
                });
            } else if (this.state.isValid == true) {
                this.setState({
                    isEmpty: false,
                    errorMessage: ''
                }, () => {
                    this.apiCallToAddWeekOff();
                });
            }
        }
        else {
            if (this.state.selectedIid == '' || Object.keys(this.state.selectedCheckboxes).length == 0 || this.state.selectedAcademicYearObject == '' || this.state.selectedDepartmentObject == '' || this.state.validFromDate == '' || this.state.validToDate == '') {
                this.setState({
                    isEmpty: true,
                    errorMessage: 'Please fill out all mandatory fields before proceeding.'
                });
            } else if (this.state.isValid == true) {
                this.setState({
                    isEmpty: false,
                    errorMessage: ''
                }, () => {
                    this.apiCallToAddWeekOff();
                }
                );
            }
        }

        // if (this.state.selectedIid == '' || Object.keys(this.state.selectedCheckboxes).length == 0 || this.state.selectedAcademicYearObject == '' || this.state.selectedDepartmentObject == '' || this.state.validFromDate == '' || this.state.validToDate == '') {
        //     this.setState({
        //         isEmpty: true,
        //         errorMessage: 'Please fill out all mandatory fields before proceeding.'
        //     });
        // } else {
        //     this.setState({
        //         isEmpty: false,
        //         errorMessage: ''
        //     }, () => {
        //         this.apiCallToAddWeekOff();
        //     }
        //     );
        // }
    }

    // METHOD TO CLOSE FILTER MODAL
    closefilterModal = () => {
        this.setState({
            filterModal: false,
            filterIid: '',
            filterAcaYr: '',
            filterDepartment: '',
            filterFromDate: '',
            filterToDate: '',
            isValid: true,
            dateErrorMessage: '',
        });
    }

    //CLEAR FILTERS
    clearFilters = () => {
        this.setState({
            filterIid: '',
            filterAcaYr: '',
            filterDepartment: '',
            filterFromDate: '',
            filterToDate: '',
            isValid: true,
            dateErrorMessage: '',
            filterApplied: false,
            filterModal: false
        }, () => this.apiCallToGetWeekOffsList());
    }

    // Apply filters
    applyFilters = () => {
        if (this.state.isValid == true) {
            this.apiCallToGetWeekOffsList();
            this.setState({
                filterModal: false,
                filterApplied: true,
                pageIndex: 1,
                offset: 0
            })
        }
    }

    // METHOD TO RETURN ADVANCED FILTERS
    returnAdvancedFilterModal = () => {
        return (
            <div id="modalContainer" className={this.state.filterModal ? "modal fade show" : "modal fade"}>
                <div className='modal-dialog modal-dialog-centered' style={{ maxWidth: '45VW', minHeight: "calc(100% - 10.5rem)" }}>
                    <div className='modal-content' style={{ borderRadius: '10px' }}>
                        <div className='modal-header p-3'>
                            <h3 style={{ textTransform: "none", fontSize: 20 }}>Advanced Filters</h3>
                            <FontAwesomeIcon
                                icon={["fas", "times"]}
                                style={{ cursor: "pointer" }}
                                size='md'
                                color='#000000'
                                onClick={() => this.closefilterModal()}
                            />
                        </div>
                        <div className='modal-body'>
                            <div className='pl-1 pr-1'>
                                <label style={{ fontWeight: "bold", fontSize: "14px" }}>Institute</label>

                                <select
                                    className="form-control"
                                    value={this.state.filterIid}
                                    onChange={(e) => { this.setState({ filterIid: e.target.value, pageIndex: 1, offset: 0, departmentList: [], filterDepartment: '' }, () => { this.GetInstituteStreamsObject(); }) }}

                                >
                                    <option value="">Select Institute</option>
                                    {
                                        Object.values(this.props.multipleInstituteDetails.multipleInstituteDetails).map(instituteList => {
                                            return (
                                                <option value={instituteList.iid}>{instituteList.institute_name}</option>
                                            );
                                        })
                                    }
                                </select>
                            </div>
                            <div className='d-flex pt-3'>
                                <div className='col-md-6 pl-1'>
                                    <label style={{ fontWeight: "bold", fontSize: "14px" }}>Academic Year</label>

                                    <select
                                        className="form-control"
                                        value={this.state.filterAcaYr}
                                        onChange={(e) => this.setState({ filterAcaYr: e.target.value, pageIndex: 1, offset: 0 })}
                                    >
                                        <option value="">Select Academic Year</option>
                                        {
                                            Object.values(config.academicInfo).map(keys => {
                                                return (
                                                    <option value={keys.YearId}>{keys.YearText}</option>
                                                );
                                            })
                                        }
                                    </select>
                                </div>
                                <div className='col-md-6 pr-1'>
                                    <label style={{ fontWeight: "bold", fontSize: "14px" }}>Department</label>

                                    <select
                                        className="form-control"
                                        value={this.state.filterDepartment}
                                        onChange={(e) => this.setState({ filterDepartment: e.target.value, pageIndex: 1, offset: 0 })}
                                    >
                                        {this.state.filterIid !== '' ? (
                                            <>
                                                <option value="">Select Department</option>
                                                {Object.keys(this.state.departments).map(keys => {
                                                    let dept = this.state.departments[keys];
                                                    return (
                                                        <option key={keys} value={keys}>{dept.stream_name}</option>
                                                    );
                                                })}
                                            </>
                                        ) : (
                                            <option value="">Please select institute.</option>
                                        )}
                                    </select>
                                </div>
                            </div>
                            <div className='d-flex pt-3'>
                                <div className="col-md-6 pl-1">
                                    <label style={{ fontWeight: "bold", fontSize: "14px" }}>From Date</label>

                                    <input
                                        type="date"
                                        className="form-control"
                                        style={{ width: "100%", paddingLeft: "10px" }}
                                        value={this.state.filterFromDate}
                                        onChange={(e) => { this.setState({ filterFromDate: e.target.value, pageIndex: 1, offset: 0 }, () => { this.validateDates(); }) }}
                                    />
                                </div>
                                <div className="col-md-6 pr-1">
                                    <label style={{ fontWeight: "bold", fontSize: "14px" }}>To Date</label>

                                    <input
                                        type="date"
                                        className="form-control"
                                        style={{ width: "100%", paddingLeft: "10px" }}
                                        value={this.state.filterToDate}
                                        onChange={(e) => { this.setState({ filterToDate: e.target.value, pageIndex: 1, offset: 0 }, () => { this.validateDates(); }) }}
                                    />
                                </div>
                            </div>
                            <p className='text-danger fs-12 pt-2'>{this.state.dateErrorMessage}</p>
                        </div>
                        <div className='modal-footer'>
                            <button className="btn btn-outline-primary waves-effect p-1" style={{ borderRadius: '5px' }} onClick={() => this.clearFilters()}>Clear</button>
                            <button className="btn btn-primary"
                                style={{ borderRadius: '5px' }}
                                onClick={() => this.applyFilters()}
                            >Apply Filters</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    //METHOD TO CHECK ACCESS FOR EDIT OPERATION
    checkEditAccess = (weekOff) => {
        const editGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['setting'].find(access => access === 'edit');

        if (editGrantAccess !== undefined) {
            let streamIds = weekOff.sidArray;
            let sidWiseName = weekOff.sidWiseName;
            let selectedDepartmentObject = [];
            Object.keys(sidWiseName).map((sid) => {
                let stream_name = sidWiseName[sid];
                let options = { "value": sid, "label": stream_name };
                selectedDepartmentObject.push(options);
            })

            let selectedDepartment = weekOff.sidArray;

            this.setState({
                addWeekOff: true,
                weekOffEditMode: true,
                weekOffCopyMode: false,
                selectedIid: weekOff.CollegeId,
                selectedAcademicYearObject: [weekOff.AcayrID],
                validFromDate: weekOff.Fromdate,
                validToDate: weekOff.Todate,
                editAcaYear: weekOff.AcayrID,
                selectedDepartment: selectedDepartment,
                selectedCheckboxes: weekOff.WeekOffObject,
                uniqueIdEdit: weekOff.Uniqueid,
                selectedDepartmentObject
            }, () => {
                this.GetInstituteStreamsObject();
            });
        }
        else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    //METHOD TO CHECK ACCESS FOR COPY OPERATION
    checkCopyAccess = (weekOff) => {
        const addGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['setting'].find(access => access === 'add');

        if (addGrantAccess !== undefined) {
            let streamIds = weekOff.sidArray;
            let sidWiseName = weekOff.sidWiseName;
            let selectedDepartmentObject = [];
            Object.keys(sidWiseName).map((sid) => {
                let stream_name = sidWiseName[sid];
                let options = { "value": sid, "label": stream_name };
                selectedDepartmentObject.push(options);
            })

            let selectedDepartment = weekOff.sidArray;

            this.setState({
                addWeekOff: true,
                weekOffEditMode: false,
                weekOffCopyMode: true,
                selectedIid: weekOff.CollegeId,
                selectedAcademicYearObject: [weekOff.AcayrID],
                validFromDate: weekOff.Fromdate,
                validToDate: weekOff.Todate,
                editAcaYear: weekOff.AcayrID,
                selectedDepartment: selectedDepartment,
                selectedCheckboxes: weekOff.WeekOffObject,
                uniqueIdEdit: weekOff.Uniqueid,
                selectedDepartmentObject
            }, () => {
                this.GetInstituteStreamsObject();
            });
        }
        else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    render() {
        return (
            <>
                <div>
                    <div>
                        <div className="pl-0 pt-2 col-md-12">
                            <div className="row d-flex justify-content-between">
                                <span className="col-md-8 pl-0">
                                    <div className="row">
                                        <div style={{ paddingTop: '10px', fontSize: "14px", textDecoration: 'underline', color: '#0080ff', cursor: 'pointer' }}
                                            onClick={() => this.setState({ filterModal: true })}
                                        >
                                            + Advanced Filters <FontAwesomeIcon icon={["fa", "filter"]} />
                                        </div>
                                    </div>
                                </span>
                                <div>
                                    <button type="button" onClick={() => (this.checkAddWeekOffs(), this.AcademicYearList())} className="btn btn-primary">
                                        <FontAwesomeIcon icon={["fa", "plus"]} /> &nbsp;
                                        Add Week offs
                                    </button>
                                </div>
                            </div>
                            {
                                this.state.filterApplied &&
                                (
                                    <div className="row mb-2">
                                        <div className="col-md-12 pl-0 pr-0">
                                            <div className="filter_containers appliedFilteredDivs" style={{ background: "#FFF", display: "flex", alignItems: "end" }}>
                                                <div>
                                                    <div style={{ paddingLeft: '15px' }}>
                                                        <label style={{ fontSize: 12, marginBottom: 0 }}>Applied Filters</label>
                                                        <div style={{ display: "flex", gap: 10, overflowX: "auto" }}>

                                                            {this.state.filterIid.length > 0 && <div class="appliedHolidayFilters"><span>Institute</span><span><FontAwesomeIcon icon={['fas', 'times']} onClick={() => { this.setState({ filterIid: "", filterDepartment: "" }, () => this.apiCallToGetWeekOffsList()) }} style={{ cursor: "pointer" }} /></span></div>}

                                                            {this.state.filterAcaYr.length > 0 && <div class="appliedHolidayFilters"><span>Academic Year</span><span><FontAwesomeIcon icon={['fas', 'times']} onClick={() => { this.setState({ filterAcaYr: "" }, () => this.apiCallToGetWeekOffsList()) }} style={{ cursor: "pointer" }} /></span></div>}

                                                            {this.state.filterDepartment.length > 0 && <div class="appliedHolidayFilters"><span>Department</span><span><FontAwesomeIcon icon={['fas', 'times']} onClick={() => { this.setState({ filterDepartment: "" }, () => this.apiCallToGetWeekOffsList()) }} style={{ cursor: "pointer" }} /></span></div>}

                                                            {this.state.filterFromDate.length > 0 && <div class="appliedHolidayFilters"><span>From Date</span><span><FontAwesomeIcon icon={['fas', 'times']} onClick={() => { this.setState({ filterFromDate: "" }, () => this.apiCallToGetWeekOffsList()) }} style={{ cursor: "pointer" }} /></span></div>}

                                                            {this.state.filterToDate.length > 0 && <div class="appliedHolidayFilters"><span>To Date</span><span><FontAwesomeIcon icon={['fas', 'times']} onClick={() => { this.setState({ filterToDate: "" }, () => this.apiCallToGetWeekOffsList()) }} style={{ cursor: "pointer" }} /></span></div>}

                                                        </div>
                                                    </div>
                                                </div>
                                                <div >
                                                    <span
                                                        className="mt-3 clearContainer"
                                                        title="Click to clear filters"
                                                        style={{ fontSize: 13, color: '#007bff', cursor: 'pointer', fontWeight: 'bold' }}
                                                        onClick={() => this.setState({ filterApplied: false, filterIid: "", filterAcaYr: "", filterDepartment: "", filterFromDate: "", filterToDate: "" }, () => this.apiCallToGetWeekOffsList())}
                                                    >
                                                        <span className='clearIcon'>
                                                            <FontAwesomeIcon icon={['fas', 'brush']} style={{ transform: "rotate(180deg)" }} />
                                                        </span> &nbsp;&nbsp;
                                                        <span style={{ textDecoration: "underline" }}>
                                                            Clear Filters
                                                        </span>
                                                    </span>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                )
                            }

                            <div className='noteRectangle'>
                                <p style={{ color: '#FF0000', fontSize: '12px' }}>Note -</p>
                                <p className='pl-3' style={{ color: '#000000', fontSize: '12px' }}><FontAwesomeIcon style={{ fontSize: "4px" }} icon={["fa", "circle"]} /> &nbsp; The Library fine will be automatically skipped for the added week offs for students.</p>
                                <p className='pl-3' style={{ color: '#000000', fontSize: '12px' }}><FontAwesomeIcon style={{ fontSize: "4px" }} icon={["fa", "circle"]} /> &nbsp; Week offs added from here will be applicable to the students only and Faculty week offs will be managed from the Leave Management System.</p>
                            </div>
                            <div className='mt-4 pb-2' style={{ paddingRight: '2%', maxHeight: '65vh', minHeight: '30vh', overflowY: 'scroll' }}>
                                {
                                    this.state.LoadingWeekoffs ?
                                        <tr>
                                            <Spinner />
                                        </tr>
                                        :

                                        Object.keys(this.state.weekOffList).length > 0 ?
                                            Object.values(this.state.weekOffList).reverse().map((weekOff) => {

                                                let Fromdate = '';
                                                let Todate = '';

                                                if (weekOff.Fromdate != "0000-00-00" && weekOff.Todate != "0000-00-00") {
                                                    Fromdate = moment(weekOff.Fromdate).format('Do MMM, YY');
                                                    Todate = moment(weekOff.Todate).format('Do MMM, YY');
                                                } else {
                                                    Fromdate = '';
                                                    Todate = ''
                                                }

                                                return (
                                                    <>
                                                        <div className='weekOffRectangle mt-3 p-3'>
                                                            <p className='col-md-12 pl-0' style={{ fontWeight: 600, fontSize: '13px' }}><span title={weekOff.instituteName}>{weekOff.instituteName.length > 50 ? weekOff.instituteName.substring(0, 75) + '...' : weekOff.instituteName}</span> | {weekOff.AcademicYear} | <span title={weekOff.streamNameArray.join(', ')}>{weekOff.streamNameArray.join(', ').length > 75 ? weekOff.streamNameArray.join(', ').substring(0, 75) + '...' : weekOff.streamNameArray.join(', ')}</span></p>
                                                            <p style={{ textTransform: "capitalize" }} className='col-md-12 pl-0 fs-12 pt-1 pb-2'>
                                                                <span style={{ fontWeight: 600 }}>Applicable Dates - </span>
                                                                {Fromdate} - {Todate}
                                                            </p>
                                                            <p style={{ textTransform: "capitalize" }} className='col-md-12 pl-0 fs-12 pb-2'><span style={{ fontWeight: 600 }}>Weekly Off Days - </span>
                                                                {Object.keys(weekOff.WeekOffObject).join(", ")}
                                                            </p>
                                                            <div className='d-flex'>
                                                                <div className='col-md-11 table-responsive'>
                                                                    <table className="table table-bordered">
                                                                        <tbody>
                                                                            {Object.entries(weekOff.WeekOffObject).map(([weekday, weekNumbers]) => (
                                                                                <tr key={weekday}>
                                                                                    <th scope="row" style={{ textTransform: "capitalize", padding: '9px', backgroundColor: '#EEF8FF', fontWeight: 600 }}>{weekday}</th>
                                                                                    {['1st', '2nd', '3rd', '4th', '5th', '6th'].map((day, index) => (
                                                                                        <td key={index} style={{ padding: '9px' }}>
                                                                                            {weekNumbers.includes(index + 1) ?
                                                                                                (
                                                                                                    <>
                                                                                                        {weekNumbers.find(weekNumber => weekNumber === index + 1) + this.getSuffix(index + 1)}{' '}
                                                                                                        <span style={{ textTransform: "capitalize" }}>{weekday}</span>
                                                                                                    </>
                                                                                                ) :
                                                                                                '-'
                                                                                            }
                                                                                        </td>
                                                                                    )
                                                                                    )}
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                                <div className='col-md-1 pr-0 d-flex justify-content-center align-items-center'>
                                                                    <FontAwesomeIcon style={{ fontSize: '15px', color: 'rgb(63, 59, 59)', cursor: 'pointer' }} onClick={() => { this.checkEditAccess(weekOff) }} title='Click to edit' icon={["fa", "edit"]} />&nbsp;&nbsp;&nbsp;&nbsp;
                                                                    <FontAwesomeIcon style={{ fontSize: '15px', color: 'rgb(63, 59, 59)', cursor: 'pointer' }} onClick={() => { this.setState({ deletingId: weekOff.Uniqueid, CollegeId: weekOff.CollegeId }, () => this.checkDeleteAccess()) }} title='Click to delete' icon={["fa", "trash-alt"]} />&nbsp;&nbsp;&nbsp;&nbsp;
                                                                    <FontAwesomeIcon style={{ fontSize: '15px', color: 'rgb(63, 59, 59)', cursor: 'pointer' }} onClick={() => { this.checkCopyAccess(weekOff) }} title='Click to copy' icon={["fa", "copy"]} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                            })
                                            :
                                            <p style={{ padding: 5 }} colSpan={13}>No week off is added yet. Please click on 'Add Week Offs' to add week off.</p>
                                }
                            </div>
                            {
                                !this.state.LoadingWeekoffs && Object.keys(this.state.weekOffList).length > 0 &&
                                <div className="pl-1 pr-1">
                                    <div style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', flexWrap: "nowrap", marginBottom: 15 }}>
                                        <div className="perPageSelectContainer" style={{ fontSize: 13, fontWeight: "bold" }}>
                                            <span >Show</span>
                                            <select
                                                className="mx-2"
                                                value={this.state.limit}
                                                onChange={(e) => this.selectLimit(e)}
                                            >
                                                <option value={10}>10</option>
                                                <option value={25}>25</option>
                                                <option value={40}>40</option>
                                                <option value={100}>100</option>
                                                <option value={250}>250</option>
                                            </select>
                                            <span>entries</span>
                                        </div>
                                        <div id="paginationContainer">
                                            <Pagination
                                                activePage={this.state.pageIndex}
                                                itemsCountPerPage={this.state.limit}
                                                totalItemsCount={this.state.totalWeekOffs}
                                                pageRangeDisplayed={3}
                                                onChange={(num) => this.updatePaginationCount(num)}
                                            />
                                        </div>
                                        <p className="mx-2" style={{ fontWeight: 'bold', fontSize: 13 }}>Total Records : {this.state.totalWeekOffs} </p>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>

                {
                    this.returnAddNewWeekOff()
                }
                {
                    this.returnAdvancedFilterModal()
                }
                {
                    this.returnDeleteAccess()
                }
                {
                    this.state.successModal &&
                    <SuccessModal
                        successModal={this.state.successModal}
                        successModalType={this.state.successModalType}
                        successMessage={this.state.successMessage}
                        closeSuccessModal={this.closeSuccessModal}
                    />
                }
            </>
        )
    }
}

const mapStateToProps = store => {
    return {
        // VARIABLES TO GET AGENCY DETAILS
        assignedInstitute: { ...store.RouteMenuReducer.assignedInstitute },
        assignedIIDArray: { ...store.RouteMenuReducer.assignedIIDArray },
        accessibleOperations: store.RouteMenuReducer.accessibleOperations,
        isAdmin: store.RouteMenuReducer.isLibraryAdmin,
        multipleInstituteDetails: { ...store.RouteMenuReducer.multipleInstituteDetails },
        iidArray: { ...store.RouteMenuReducer.iidArray },
    };
};


export default connect(mapStateToProps)(WeekOffs);
